import { IActivity } from "@wingspanhq/users";
import {
  VerificationLevel,
  VerificationLevels
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsOnboardingComplete = (
  activity?: IActivity,
  verifications?: VerificationLevels
) =>
  (activity?.flows.paymentsSetup &&
    activity.flows.paymentsSetup.currentStep &&
    (activity.flows.paymentsSetup.currentStep >= 3 ||
      activity.flows.paymentsSetup.complete)) ||
  (verifications?.tax && verifications.tax !== VerificationLevel.NONE);
